import { render, staticRenderFns } from "./TeamLeaderMaster.vue?vue&type=template&id=6672e614&scoped=true&"
import script from "./TeamLeaderMaster.vue?vue&type=script&lang=js&"
export * from "./TeamLeaderMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6672e614",
  null
  
)

export default component.exports